var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wl-container" }, [
    _c(
      "div",
      { staticClass: "wl-content-container" },
      [
        _c("div", { staticClass: "wl-search-bar" }, [
          _c(
            "div",
            { staticClass: "wl-left" },
            [
              _c(
                "el-input",
                {
                  staticClass: "input-with-select",
                  attrs: {
                    placeholder: _vm.$t(
                      "KPMG_SYSTEM_ADMIN_MANAGEMENT_PLACE_HOLDER"
                    ),
                    maxlength: "100",
                    clearable: "",
                  },
                  on: { clear: _vm.searchAdmin },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.searchAdmin.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.searchContent,
                    callback: function ($$v) {
                      _vm.searchContent = $$v
                    },
                    expression: "searchContent",
                  },
                },
                [
                  _c("i", {
                    staticClass: "el-input__icon el-icon-search",
                    staticStyle: { cursor: "pointer" },
                    attrs: { slot: "suffix" },
                    on: { click: _vm.searchAdmin },
                    slot: "suffix",
                  }),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "wl-right" },
            [
              _c("select-ad", {
                ref: "selectAdd",
                staticClass: "wl-select-add",
                attrs: {
                  api: _vm.selectFromUser,
                  filter: _vm.adFilter,
                  onAdd: _vm.onAddAccount,
                },
              }),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "table-container-wrapper" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                attrs: {
                  height: "100%",
                  data: _vm.data,
                  border: "",
                  stripe: "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: { type: "index", width: "70" },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "staffNo",
                    label: _vm.$t("TABLE_HEADER_EMAIL_StaffNo"),
                    width: "120",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "userName",
                    width: "220",
                    label: _vm.$t("TABLE_HEADER_EMAIL_StaffName"),
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "profitCenter",
                    width: "200",
                    label: _vm.$t("TABLE_HEADER_EMAIL_ProfitCenter"),
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "position",
                    width: "300",
                    label: _vm.$t("TABLE_HEADER_EMAIL_Position"),
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "email",
                    label: _vm.$t("TABLE_HEADER_EMAIL_Email"),
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "action",
                    width: "100",
                    align: "center",
                    fixed: "right",
                    label: _vm.$t("TABLE_HEADER_Action"),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("i", {
                            staticClass: "el-icon-delete wl-icon-delete",
                            on: {
                              click: function ($event) {
                                return _vm.onDeleteAccount(scope.row)
                              },
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c("el-pagination", {
          staticClass: "wl-pagination",
          attrs: {
            "current-page": _vm.pagination.pageNum,
            "page-size": _vm.pagination.pageSize,
            "page-sizes": [10, 50, 100],
            layout: "prev, pager, next, sizes, total",
            total: _vm.pagination.total,
          },
          on: {
            "current-change": _vm.onCurrentPageChange,
            "size-change": _vm.onSizeChange,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }